/**
 * @whatItDoes Conditionally includes an HTML element if current user has not
 * the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *jhiHasNotAnyAuthority="'ROLE_ADMIN'">...</some-element>
 *
 *     <some-element *jhiHasNotAnyAuthority="['ROLE_ADMIN', 'ROLE_USER']">...</some-element>
 * ```
 */
import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Principal } from './principal.service';
import { SubscriptionsManager } from '../util/subscriptions-manager';

@Directive({
    selector: '[jhiHasNotAnyAuthority]'
})
export class HasNotAnyAuthorityDirective implements OnDestroy {

    subscriptionsManager = new SubscriptionsManager();

    private authorities: string[];

    constructor(private principal: Principal, private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef) {
    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    @Input()
    set jhiHasNotAnyAuthority(value: string | string[]) {
        this.authorities = typeof value === 'string' ? [<string>value] : <string[]>value;
        this.updateView();
        // Get notified each time authentication state changes.
        this.subscriptionsManager.add = this.principal.getAuthenticationState().subscribe((identity) => this.updateView());
    }

    private updateView(): void {
        this.principal.hasAnyAuthority(this.authorities).then((result) => {
            this.viewContainerRef.clear();
            if (!result) {
                this.viewContainerRef.createEmbeddedView(this.templateRef);
            }
        });
    }
}
